import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Shield } from 'lucide-react';

interface AccessDeniedProps {
  title?: string;
  description?: string;
}

export function AccessDenied({ 
  title = 'Access Denied',
  description = 'You do not have permission to access this resource. Please contact your administrator if you believe this is an error.'
}: AccessDeniedProps) {
  return (
    <div className="flex items-center justify-center min-h-[400px] p-6">
      <Card className="w-full max-w-md">
        <CardHeader className="text-center">
          <div className="mx-auto w-12 h-12 bg-destructive/10 rounded-full flex items-center justify-center mb-4">
            <Shield className="w-6 h-6 text-destructive" />
          </div>
          <CardTitle className="text-xl">{title}</CardTitle>
          <CardDescription>{description}</CardDescription>
        </CardHeader>
        <CardContent className="text-center">
          <p className="text-sm text-muted-foreground">
            Required permissions: Admin, Owner, or Super Admin
          </p>
        </CardContent>
      </Card>
    </div>
  );
}

